import { WindowId } from './WindowManager';

/**
 * Central config for default window layout.
 * Order determines grid placement (left-to-right, top-to-bottom).
 */
const DEFAULT_LAYOUT: WindowId[] = [WindowId.Terminal, WindowId.Browser];

const GAP = 32;
const MIN_COLUMN_WIDTH = 400;

/**
 * Returns a computeDefaults callback for a window in the default layout.
 * Windows not in DEFAULT_LAYOUT get undefined (no responsive defaults).
 */
export function computeWindowDefaults(windowId: WindowId) {
  const index = DEFAULT_LAYOUT.indexOf(windowId);
  if (index === -1) return undefined;

  return (desktopWidth: number, desktopHeight: number) => {
    const count = DEFAULT_LAYOUT.length;

    // Columns adapt to available width: as many as fit at MIN_COLUMN_WIDTH, capped by window count
    const cols = Math.max(1, Math.min(count, Math.floor((desktopWidth + GAP) / (MIN_COLUMN_WIDTH + GAP))));
    const rows = Math.ceil(count / cols);

    const col = index % cols;
    const row = Math.floor(index / cols);

    const width = Math.floor((desktopWidth - GAP * (cols + 1)) / cols);
    const height = Math.floor((desktopHeight - GAP * (rows + 1)) / rows);

    return {
      size: { width, height },
      position: {
        x: GAP + col * (width + GAP),
        y: GAP + row * (height + GAP),
      },
    };
  };
}
